import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import meoUpdate from '../assets/meo_3d_coucou.png'; // Image Meo qui salue pour la mise à jour

const Overlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(46, 46, 46, 0.75);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PopupSheet = styled.div`
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 105%;
  max-width: 600px;
  height: 420px;
  border-radius: 35px 35px 0 0;
  border: 1px solid rgba(188, 187, 187, 0.50);
  background: #FFFEFE;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px -2px 24px 0px rgba(46,46,46,0.10);
  animation: slideUp 0.4s cubic-bezier(0.4,0,0.2,1);

  @keyframes slideUp {
    from {
      transform: translateX(-50%) translateY(100%);
    }
    to {
      transform: translateX(-50%) translateY(0);
    }
  }
`;

const PopupContentContainer = styled.div`
  width: 100%;
  padding: 40px 24px 20px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const TopSquare = styled.div`
  width: 35px;
  height: 5px;
  border-radius: 20px;
  background: rgba(202, 202, 202, 0.5);
  margin-top: -30px;
`;

const Title = styled.div`
  color: rgba(122, 122, 122, 0.80);
  text-align: center;
  font-family: Gabarito, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 10px;
`;

const Subtitle = styled.div`
  color: rgba(122, 122, 122, 0.70);
  text-align: center;
  font-family: Gabarito, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 12px;
  padding: 0 16px;
`;

const MeoImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-top: 16px;
`;

const OptionGlobalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 24px 40px 24px;
  margin-top: auto;
`;

const UpdateButton = styled.div`
  border-radius: 20px;
  border: 1px solid rgba(93, 156, 236, 0.50);
  background: linear-gradient(135deg, #5D9CEC 0%, #4A8FE7 100%);
  box-shadow: 0 2px 8px 0 rgba(93, 156, 236, 0.30);
  width: 100%;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.18s cubic-bezier(0.4,0,0.2,1), transform 0.18s cubic-bezier(0.4,0,0.2,1);
  
  &.active, &[data-active="true"] {
    box-shadow: 0 1px 4px 0 rgba(93, 156, 236, 0.20);
    transform: scale(0.97) translateY(1px);
  }
`;

const ButtonText = styled.span`
  color: #FFFFFF;
  text-align: center;
  font-family: Gabarito, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const UpdatePromptPopup = ({ isVisible, onUpdate }) => {
  const [activeButton, setActiveButton] = useState(false);

  if (!isVisible) return null;

  const handleUpdate = () => {
    console.log('[UpdatePromptPopup] User clicked update button');
    onUpdate();
  };

  return (
    <Overlay>
      <PopupSheet>
        <PopupContentContainer>
          <TopSquare />
          <Title>Nouvelle version disponible !</Title>
          <MeoImage src={meoUpdate} alt="Meo" />
          <Subtitle>
            Une mise à jour est prête. Cliquez sur le bouton ci-dessous pour profiter des dernières améliorations.
          </Subtitle>
        </PopupContentContainer>
        <OptionGlobalContainer>
          <UpdateButton
            data-active={activeButton}
            onMouseDown={(e) => { e.stopPropagation(); setActiveButton(true); }}
            onMouseUp={(e) => { e.stopPropagation(); setActiveButton(false); handleUpdate(); }}
            onMouseLeave={() => setActiveButton(false)}
            onTouchStart={(e) => { e.stopPropagation(); setActiveButton(true); }}
            onTouchEnd={(e) => { e.stopPropagation(); setActiveButton(false); handleUpdate(); }}
          >
            <ButtonText>Mettre à jour maintenant</ButtonText>
          </UpdateButton>
        </OptionGlobalContainer>
      </PopupSheet>
    </Overlay>
  );
};

export default UpdatePromptPopup;
